import React from 'react';

import { useReturnAuthorizationsActivity_TabBarQuery } from 'generated/graphql';
import { tableUtil } from 'modules';



export interface IData {
  numPendingApproval: number;
  numPendingReceipt: number;
  numPendingShippingLabel: number;
  numPendingAcceptance: number;
  numPendingRefund: number;
}

export function useQuery(storeId?: string) {
  const tuple = useReturnAuthorizationsActivity_TabBarQuery({
    variables: { storeId: storeId || undefined }
  });

  tableUtil.useRefetchOverInterval(tuple, 5000);

  return React.useMemo(
    () => {
      const data: IData = {
        numPendingApproval: tuple.data?.pendingApproval.pageInfo.totalRows ?? 0,
        numPendingReceipt: tuple.data?.pendingReceipt.pageInfo.totalRows ?? 0,
        numPendingShippingLabel: tuple.data?.pendingShippingLabel.pageInfo.totalRows ?? 0,
        numPendingAcceptance: tuple.data?.pendingAcceptance.pageInfo.totalRows ?? 0,
        numPendingRefund: tuple.data?.pendingRefund.pageInfo.totalRows ?? 0
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
